exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".claimed-items-bar{display:-ms-flexbox;display:flex;-ms-flex-pack:right;justify-content:right;-ms-flex-align:center;align-items:center;width:100vw;position:fixed;bottom:65px;left:0;padding:12px 12px 12px 0;-webkit-box-shadow:-3px -5px 24px -21px #42445a;box-shadow:-3px -5px 24px -21px #42445a;z-index:10}@media (max-width: 1099px){.claimed-items-bar{display:none}}.claimed-items-bar .btn{min-width:150px;margin-left:10px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/containers/embeddable/utils/ClaimedItemsBar.scss
// module id = 737
// module chunks = 1